export enum UserRole {
  ADMIN = "ADMIN",
  USER = "USER",
  RESELLER_ADMIN = "RESELLER_ADMIN",
  BRAND_ADMIN = "BRAND_ADMIN",
}
